import { render, staticRenderFns } from "./BillList.vue?vue&type=template&id=752fae28&"
import script from "./BillList.vue?vue&type=script&lang=ts&"
export * from "./BillList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports